import { doGET } from "../../../util/HttpUtil";
import { STEPS } from "./IPlushelper";

export const STEP_NUM =  {
    INTRODUCTION: 1,
    BUSINESS_DETAILS: 2,
    BUSINESS_ACTIVITY: 3,
    BUSINESS_COMPLIANCE: 4,
    DOCUMENTS: 5,
    SELF_DECLARATION : 6,
    REFERRAL_AND_SOURCE: 7,
    PAY_NOW: 8,
    LAST_STEP: 8,
    APPLICATION_FORM_REDO: 9,
    THANK_YOU: Number.MAX_SAFE_INTEGER
}

export const getBPlusStepNumberWhenRedo = (step) => {
    switch (step) {
        case STEPS.APPLICATION_FORM:
            return STEP_NUM.APPLICATION_FORM_REDO;
        case STEPS.KYC_VERIFICATION:
            return STEP_NUM.THANK_YOU;
        case STEPS.SANCTIONS_SCREENING:
            return STEP_NUM.THANK_YOU;
        case STEPS.DOCUMENT_VERIFICATION:
            return STEP_NUM.THANK_YOU;
        case STEPS.RISK_ASSESSMENT:
            return STEP_NUM.THANK_YOU;
        default:
            return 0;
    }
}

export const fetchBPlusData = async (formId) => {
    try {
        const response = await doGET(`/api/business-lite/detail?id=${formId}`);
        return response.data ?? {};
    } catch (error) {
        console.log(error);
        return {};
    }
};

export const fetchBPrimeData = async (formId) => {
    try {
        const response = await doGET(`/api/business-prime/detail?id=${formId}`);
        return response.data ?? {};
    } catch (error) {
        console.log(error);
        return {};
    }
};

